import { RideitPassengerTokenStatus } from './RideitPassengerToken';
import { getInvitationStatus, getLatestInvitationPerPhoneNumber, IRideitInvitationTableItem, RideitInvitationWithSmsStatus } from '@/util/rideitHelper';
import { IRideitCreateInvitationsRequest, IRideitInvitationRequest } from '@/typings/rideit';

export interface IRideitInvitationFormData {
  message: string;
  onlyPassengersWithoutActiveTokens: boolean;
  onlyNewInvitations: boolean;
  selected: IRideitInvitationTableItem[];
}


export default class RideitInvitationFormData implements IRideitInvitationFormData {
  message: string;
  onlyPassengersWithoutActiveTokens: boolean;
  onlyNewInvitations: boolean;
  selected: IRideitInvitationTableItem[];
  
  constructor(data?: IRideitInvitationFormData | null) {
    this.message = data?.message ?? '';
    this.onlyPassengersWithoutActiveTokens = data?.onlyPassengersWithoutActiveTokens ?? false;
    this.onlyNewInvitations = data?.onlyNewInvitations ?? true;
    this.selected = data?.selected ?? [];
  }

  getInviteablePhoneNumbersFromItem(item: IRideitInvitationTableItem) {
    let phoneNumbers = item.passenger.phoneNumbers?.filter(pn => pn.sms) ?? [];

    if (phoneNumbers.length === 0) {
      return [];
    }

    const activeTokens = item.tokens.filter(t => t.status === RideitPassengerTokenStatus.Active);
    if (this.onlyPassengersWithoutActiveTokens && activeTokens.length > 0) {
      return [];
    }

    if (this.onlyNewInvitations) {
      const latestInvitations = getLatestInvitationPerPhoneNumber(item.invitations, item.passenger.smsMessages);
      
      const activeStatuses = [
        RideitInvitationWithSmsStatus.Pending, 
        RideitInvitationWithSmsStatus.Sent, 
        RideitInvitationWithSmsStatus.Accepted
      ];

      const activeInvitations = latestInvitations
        .filter(i => activeStatuses.includes(getInvitationStatus(i.invitation, i.smsMessage)));

      phoneNumbers = phoneNumbers.filter(pn => !activeInvitations.some(i => this.isTheSamePhoneNumber(pn.number, i.smsMessage.to)))
    }
    
    return phoneNumbers;
  }

  get createInvitationsRequest() {
    const uniquePhoneNumbers = this.selected
    .flatMap(item => this.getInviteablePhoneNumbersFromItem(item))
    .filter(((x, i, a) => a.findIndex(ax => ax.number === x.number) === i));

    const invitations =  uniquePhoneNumbers.map(pn => {
      const passengers = this.selected
      .filter(i => i.passenger.phoneNumbers?.some(ppn => ppn.number === pn.number))
      .map(i => i.passenger);

      return {
        phoneNumber: pn.number,
        passengers: passengers,
      }
    }) as IRideitInvitationRequest[];
    return { messageTemplate: this.message, invitations: invitations } as IRideitCreateInvitationsRequest;
  }



  private isTheSamePhoneNumber(phoneNumber: string, smsNumber: string) {
    let phoneNumberNumbers = phoneNumber.match(/\d+/g)?.join('') ?? '';
    if (phoneNumberNumbers.startsWith('0')) {
      phoneNumberNumbers = phoneNumberNumbers.substring(1);
    }
    return smsNumber.endsWith(phoneNumberNumbers);
  }

}
